'use-client';
import * as React from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import type { IPopupContainerProps } from '../PopupContainer.types';
import FillLayers from '@wix/thunderbolt-elements/components/FillLayers';
import semanticClassNames from '../PopupContainer.semanticClassNames';
import { useEffect } from 'react';

const PopupContainer: React.FC<IPopupContainerProps> = props => {
  const {
    id,
    fillLayers,
    children,
    className,
    customClassNames = [],
    setSiteScrollingBlocked,
    isDocumentScrollEnabled,
    onMouseEnter,
    onMouseLeave,
    lang,
  } = props;
  const sdkEventHandlers = { onMouseEnter, onMouseLeave };

  useEffect(() => {
    if (isDocumentScrollEnabled) {
      return;
    }

    setSiteScrollingBlocked(true, id);
    return () => setSiteScrollingBlocked(false, id);
  }, [id, isDocumentScrollEnabled, setSiteScrollingBlocked]);

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      {...sdkEventHandlers}
      data-block-level-container="PopupContainer"
      lang={lang}
    >
      <FillLayers {...fillLayers} />
      {children()}
    </div>
  );
};

export default PopupContainer;
